import {ReactNode} from 'react';
import clsx from 'clsx';
interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
  customMargin?: string;
}
export function AuthLayout({
  heading: _heading,
  children,
  message: _message,
  customMargin: _customMargin,
}: AuthPageProps) {
  return (
    <main className={clsx(
      'relative cursor-default min-h-screen flex flex-col transition-colors duration-300 bg'
    )}>
      <div className="min-w-[300px] mx-auto flex-1 flex flex-col w-full">
        {children}
      </div>
    </main>
  );
}
